<template>
  <Bar
    :data="chartData"
    :options="options"
    :width="width"
    :height="height"
    :plugins="plugins"
  />
</template>

<script>
import { Bar } from 'vue-chartjs'

export default {
  name: 'Chart',
  components: {
    Bar
  },
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    }
  },
  computed: {
    plugins () {
      return [
        {
          id: 'mycolors',
          beforeUpdate: (chart) => {
            const colors = ['#A6CEE3', '#1F78B4', '#B2DF8A', '#33A02C', '#FB9A99', '#E31A1C', '#FDBF6F', '#FF7F00', '#CAB2D6', '#6A3D9A', '#FFFF99', '#B15928']
            for (const i in chart.data.datasets) {
              chart.data.datasets[i].backgroundColor = chart.data.datasets[i].backgroundColor || colors[i]
              if (chart.data.datasets[i].type === 'line') {
                chart.data.datasets[i].borderColor = chart.data.datasets[i].borderColor || colors[i]
              }
            }
          }
        }
      ]
    }
  }
}
</script>

<style scoped>
</style>
